import type { MedicalHistoryRecordPatch } from "./medicalHistoryRecordFixture";

/**
 * Family History deep-link record.
 *
 * Every step of the flow renders the answer the patient already gave —
 * `FamilyHistoryContext` hydrates it off `patient.familyHistory` — so a deep
 * link onto a step of an unanswered record shows the question with nothing
 * chosen and tells a reviewer nothing about the answered state. The patch is
 * the `familyHistory` payload the patient endpoint returns for a record whose
 * section is complete: the same field names and entry shapes
 * `transformFamilyHistoryStateToRequest` PATCHes and the same ones the
 * context's hydration reads back.
 */
export const FAMILY_HISTORY_RECORD_FIXTURES: Record<
  string,
  MedicalHistoryRecordPatch
> = {
  "family-history-answered": {
    familyHistory: {
      id: "family-history-fixture",
      ancestryHistory: [
        { id: "ancestry-fixture-1", ancestry: "caucasian" },
        { id: "ancestry-fixture-2", ancestry: "asian" },
      ],
      hasDoneDNAAncestryReport: true,
      dnaAncestryDocumentId: "dna-ancestry-report-fixture",
      dnaAncestryReportDate: "2024-03-15",
      adoptionStatus: "not_adopted",
      hasRelativeFacingFertilityIssues: "yes",
      familyMemberWithFertilityIssues: [
        { id: "family-member-fixture-1", familyMember: "sister" },
        {
          id: "family-member-fixture-2",
          familyMember: "grandmother_mother_side",
        },
      ],
      hasMotherTakenDESDuringPregnancy: "unknown",
      diseasesMothersSide: "Breast cancer, thyroid disease.",
      diseasesFathersSide: "Hypertension, type 2 diabetes.",
    },
  },
};
